import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Spinner } from "react-bootstrap";
import { FaUndoAlt } from "react-icons/fa";
import { AssetReturnCancelApi } from "../../../services/AssetService";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
const AssetReturnCancelModal = ({ open, onClose, assetData, afterSubmit }) => {
  const { asset, model_number, serial_number, brand, purchase_cost } =
    assetData || {};
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState("");
  useEffect(() => {
    if (open) {
      setRemark("");
    }
  }, [open]);
  const handleConfirm = () => {
    setLoading(true);
    AssetReturnCancelApi(asset, { remarks: remark })
      .then((res) => {
        toast.success("Return Canceled");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger fw-semibold fs-5">
        <FaUndoAlt className="fs-4" />
        <span>Cancel Return Request</span>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" className="mb-3">
          Are you sure you want to cancel the return request for this asset?
        </Typography>
        <div className="border rounded p-3 bg-light mb-2">
          <Typography variant="body2" className="mb-1">
            <strong>Model Number:</strong> {model_number || "N/A"}
          </Typography>
          <Typography variant="body2" className="mb-1">
            <strong>Serial Number:</strong> {serial_number || "N/A"}
          </Typography>
          <Typography variant="body2" className="mb-1">
            <strong>Brand:</strong> {brand || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>Purchase Cost:</strong> ₹
            {purchase_cost?.toLocaleString() || "N/A"}
          </Typography>
        </div>
        <TextField
          autoFocus
          label="Remarks"
          fullWidth
          value={remark}
          multiline
          rows={2}
          onChange={(e) => {
            const value = e.target.value;
            setRemark(value || "");
          }}
          placeholder="Enter remarks"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetReturnCancelModal;
